<template>
    <div id="main404">
        <div class="fof">
            <h1>404 :: Page not found</h1>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style scoped>
    *{
        transition: all 0.6s;
    }

    html {
        height: 100%;
    }

    body{
        font-family: 'Lato', sans-serif;
        color: #888;
        margin: 0;
    }

    #main404{
        display: table;
        width: 100%;
        height: 100vh;
        padding-bottom: 192px;
        text-align: center;
    }

    .fof{
        display: table-cell;
        vertical-align: middle;
    }

    .fof h1{
        font-size: 50px;
        display: inline-block;
        padding-right: 12px;
        animation: type .5s alternate infinite;
    }

    @keyframes type{
        from{box-shadow: inset -3px 0 0 #888;}
        to{box-shadow: inset -3px 0 0 transparent;}
    }
</style>
